"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgDate(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M15 0a1 1 0 011 1h4v15H4V1h4a1 1 0 112 0h4a1 1 0 011-1zm3 6H6v8h12zM9 7v2H7V7zm4 0v2h-2V7zm4 0v2h-2V7z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Date')(SvgDate);
//# sourceMappingURL=Date.js.map